import { useLang } from "../i18n/LanguageContext";
import { LINKS } from "../config/brand";
import { ActionCard } from "./ActionCard";
import { TILES } from "./BrandTiles";
import { Reveal, SectionLabel } from "./Reveal";

const CARDS = [
  { id: "etoro", accent: "#13C636" },
  { id: "results", accent: "#D4AF37", internal: true, url: "/risultati" },
  { id: "telegram", accent: "#2AABEE" },
  { id: "instagram", accent: "#E1306C" },
  { id: "website", accent: "#F59E0B" },
  { id: "trustpilot", accent: "#00B67A" },
];

export const ActionList = () => {
  const { t } = useLang();
  return (
    <section data-testid="actions-section">
      <Reveal>
        <SectionLabel index="02" testId="actions-kicker">{t.actions.kicker}</SectionLabel>
        <h2 className="mt-5 font-display text-3xl font-bold tracking-tight text-zinc-50 sm:text-4xl" data-testid="actions-title">
          {t.actions.title}
        </h2>
      </Reveal>
      <div className="mt-8 flex flex-col gap-3 sm:gap-4">
        {CARDS.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.06}>
            <ActionCard {...c} tile={TILES[c.id]} index={String(i + 1).padStart(2, "0")} url={c.url || LINKS[c.id]} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};
